import { render, staticRenderFns } from "./SuppliesCreate.vue?vue&type=template&id=5f3b5b80&scoped=true&"
import script from "./SuppliesCreate.vue?vue&type=script&lang=js&"
export * from "./SuppliesCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f3b5b80",
  null
  
)

export default component.exports